<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <!--            <div class="input-group">
              <input
                type="text"
                id="search-sources"
                aria-label="SearchSources"
                aria-describedby="SearchSources"
                placeholder="Search campaigns"
                class="form-control mr-2"
                v-model="searchWord"
              />
            </div> -->
            <button
              type="button"
              class="ml-auto btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#addCampaignModal"
            >
              Add Price Plan
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Price Plan</th>
                  <th scope="col">Campaign</th>
                  <th scope="col">Country</th>
                  <th scope="col">General</th>
                  <th scope="col">Type</th>
                  <th style="text-align: right; white-space: nowrap;" scope="col">
                    Starting fee
                  </th>
                  <th style="text-align: right;white-space: nowrap;" scope="col">
                    Recruiting fee
                  </th>
                  <th style="text-align: right;white-space: nowrap;" scope="col">
                    test fee
                  </th>
                  <th scope="col">Currency</th>
                  <th scope="col">Default</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="plan in currentPricePlans">
                  <th>
                    <div class="d-flex align-items-center">{{ plan.price_plan }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ plan.campaign }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ plan.country_name }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ plan.general ? 'Yes' : 'No' }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ getPlanType(plan.type) }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center" style="justify-content: right;">
                      {{ formatPrice(plan.starting_fee) }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center" style="justify-content: right;">
                      {{ formatPrice(plan.recruiting_fee) }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center" style="justify-content: right;">
                      {{ formatPrice(plan.programming_test_fee) }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      {{ plan.currency_code }}
                    </div>
                  </th>
                  <th>
                    {{ plan.default ? 'Yes' : 'No' }}
                  </th>
                  <th style="white-space: nowrap;">
                    <button
                      @click="setPlanForEdit(plan)"
                      class="btn btn-link"
                      data-bs-toggle="modal"
                      data-bs-target="#editCampaignModal"
                    >
                      <i
                        style="font-size: 16px;
            color: #666; cursor:pointer"
                        class="fas fa-pencil-alt"
                      ></i>
                    </button>
                    <button
                      class="btn btn-link"
                      @click="setPlanForEdit(plan)"
                      data-bs-toggle="modal"
                      data-bs-target="#deleteCampaignModal"
                    >
                      <svgHelper name="delete"></svgHelper>
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />

    <div
      class="modal fade add-user-modal"
      id="addCampaignModal"
      tabindex="-1"
      aria-labelledby="addCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addCampaignModalTitle">Add Price Plan</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeAdd"
              @click="resetModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div>
              <div class="form-group m-label-left">
                <input id="desc" type="text" class="form-control" v-model="descriptionText" />
                <label for="desc">Description</label>
              </div>

              <div class="form-group m-label-left">
                <select @change="checkforPlan" v-model="camId" class="form-select" id="campaign">
                  <option value="">No campaign</option>
                  <option v-for="campain in campaigns" :value="campain.id">{{
                    campain.campaign
                  }}</option>
                </select>
                <label for="campaign">Campaign</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-4">
                  <select
                    @change="deleteCountry"
                    v-model="general"
                    class="form-select"
                    id="general"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                  <label for="general">General</label>
                </div>
                <div class="form-group m-label pp-plan col-md-8">
                  <v-select
                    :disabled="general"
                    id="country"
                    v-model="countryId"
                    label="name"
                    :options="[...getAllCountries]"
                  ></v-select>
                  <label for="country">Country</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <select v-model="type" class="form-select" id="general">
                  <option value="1">Sourcing</option>
                  <option value="2">Full-service</option>
                  <option value="3">Nearshore</option>
                  <option value="4">Freelancers</option>
                </select>
                <label for="general">Type</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-6">
                  <input id="stFee" type="text" class="form-control" v-model="startingFee" />
                  <label for="stFee">Starting fee</label>
                </div>

                <div class="form-group m-label col-md-6">
                  <input id="recFee" type="text" class="form-control" v-model="recruitingFee" />
                  <label for="recFee">Recruiting fee</label>
                </div>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-6">
                  <input id="desc" type="text" class="form-control" v-model="prFee" />
                  <label for="desc">Programming test fee</label>
                </div>

                <div class="form-group m-label-left pp-plan col-md-6">
                  <v-select
                    id="currency"
                    v-model="currencyId"
                    label="code"
                    :options="currencies"
                  ></v-select>
                  <label for="currency">Currency</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <select
                  :disabled="camId.length > 0"
                  v-model="isDefault"
                  class="form-select"
                  id="general"
                >
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
                <label for="general">Default</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="addPricePlan()" type="button" class="btn btn-primary">
              Save
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->

    <div
      class="modal fade add-user-modal"
      id="editCampaignModal"
      tabindex="-1"
      aria-labelledby="editCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editCampaignModalTitle">Edit Price Plan</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="editModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div>
              <div class="form-group m-label-left">
                <input
                  id="desc"
                  type="text"
                  class="form-control"
                  v-model="editPlan.descriptionText"
                />
                <label for="desc">Description text</label>
              </div>

              <div class="form-group m-label-left">
                <select
                  @change="checkforPlanEdit"
                  v-model="editPlan.camId"
                  class="form-select"
                  id="campaign"
                >
                  <option value="">No campaign</option>
                  <option v-for="campain in campaigns" :value="campain.id">{{
                    campain.campaign
                  }}</option>
                </select>
                <label for="campaign">Campaign</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-4">
                  <select
                    @change="deleteCountry"
                    v-model="editPlan.general"
                    class="form-select"
                    id="general"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                  <label for="general">General</label>
                </div>
                <div class="form-group m-label col-md-8 pp-plan">
                  <v-select
                    :disabled="editPlan.general"
                    id="country"
                    v-model="editPlan.country"
                    label="name"
                    :options="[...getAllCountries]"
                  ></v-select>
                  <label for="country">Country</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <select v-model="editPlan.type" class="form-select" id="type">
                  <option value="1">Sourcing</option>
                  <option value="2">Full-service</option>
                  <option value="3">Nearshore</option>
                  <option value="4">Freelancers</option>
                </select>
                <label for="type">Type</label>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-6">
                  <input
                    id="stFee"
                    type="text"
                    class="form-control"
                    v-model="editPlan.startingFee"
                  />
                  <label for="stFee">Starting fee</label>
                </div>

                <div class="form-group m-label col-md-6">
                  <input
                    id="recFee"
                    type="text"
                    class="form-control"
                    v-model="editPlan.recruitingFee"
                  />
                  <label for="recFee">Recruiting fee</label>
                </div>
              </div>

              <div class="row">
                <div class="form-group m-label col-md-6">
                  <input id="desc" type="text" class="form-control" v-model="editPlan.prFee" />
                  <label for="desc">Programming test fee</label>
                </div>

                <div class="form-group m-label col-md-6 pp-plan">
                  <v-select
                    id="currency"
                    v-model="editPlan.currency"
                    label="code"
                    :options="currencies"
                  ></v-select>
                  <label for="currency">Currency</label>
                </div>
              </div>

              <div class="form-group m-label-left">
                <select
                  :disabled="editPlan.camId.length > 0"
                  v-model="editPlan.isDefault"
                  class="form-select"
                  id="general"
                >
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
                <label for="general">Default</label>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="editPricePlan()" type="button" class="btn btn-primary">
              Save
            </button>

            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Modal -->

    <div
      class="modal fade add-user-modal"
      id="deleteCampaignModal"
      tabindex="-1"
      aria-labelledby="deleteCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteCampaignModalTitle">Delete Price Plan</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="deleteModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <p>Please confirm that you want to delete the price plan</p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deletePricePlan()" type="button" class="btn btn-primary">
              Delete
            </button>

            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'Price Plans | Jobshark';
  },
  /*   description() {
      return 'Page description goes here.';
    }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/campaigns';
  },
  components: {},
  data: () => ({
    isLoading: false,
    currencies: [],
    currentPricePlans: [],
    camId: '',
    descriptionText: '',
    countryId: '',
    general: true,
    prFee: '',
    type: '1',
    startingFee: '',
    recruitingFee: '',
    currencyId: {
      code: 'EUR',
      created_at: null,
      id: 31,
      name: 'Euro',
      symbol: '€',
      updated_at: null,
    },
    isDefault: false,

    editPlan: {
      id: '',
      descriptionText: '',
      country: {},
      general: true,
      prFee: '',
      type: '1',
      startingFee: '',
      recruitingFee: '',
      currency: {},
      isDefault: true,
      camId: '',
      camName: '',
      planID: '',
    },
    campaigns: [],
  }),
  methods: {
    checkforPlan() {
      if (this.camId !== null || this.camId !== '') {
        this.isDefault = false;
      }
    },

    checkforPlanEdit() {
      if (this.editPlan.camId !== null || this.editPlan.camId !== '') {
        this.editPlan.isDefault = false;
      }
    },
    getCampaigns() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/list`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.campaigns = res.data;
      });
    },
    formatPrice(value) {
      const str = String(value).replace(',', '.');
      let num = parseFloat(str);
      if (isNaN(num)) return '';
      num = Math.round(num);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    deleteCountry() {
      this.countryId = '';
      this.editPlan.country = {};
    },
    getPricePlans() {
      axios(`${process.env.VUE_APP_API_URL}/admin/priceplan/get`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.currentPricePlans = res.data;
      });
    },
    addPricePlan() {
      axios(`${process.env.VUE_APP_API_URL}/admin/priceplan/create`, {
        method: 'post',
        data: {
          price_plan: this.descriptionText,
          country_id: this.countryId.id,
          general: this.general,
          type: this.type,
          starting_fee: this.startingFee,
          recruiting_fee: this.recruitingFee,
          programming_test_fee: this.prFee,
          currency_id: this.currencyId.id,
          default: this.isDefault,
          campaign_id: this.camId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$refs.closeAdd.click();
        this.$toasted.success('Saved', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        this.getPricePlans();
      });
    },

    editPricePlan() {
      axios(`${process.env.VUE_APP_API_URL}/admin/priceplan/update`, {
        method: 'post',
        data: {
          price_plan_id: this.editPlan.id,
          price_plan: this.editPlan.descriptionText,
          country_id: this.editPlan.country.id,
          general: this.editPlan.general,
          type: this.editPlan.type,
          starting_fee: this.editPlan.startingFee,
          recruiting_fee: this.editPlan.recruitingFee,
          programming_test_fee: this.editPlan.prFee,
          currency_id: this.editPlan.currency.id,
          default: this.editPlan.isDefault,
          campaign_id: this.editPlan.camId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.$refs.editModal.click();
        this.$toasted.success('Saved', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        this.getPricePlans();
      });
    },

    deletePricePlan() {
      axios(`${process.env.VUE_APP_API_URL}/admin/priceplan/delete`, {
        method: 'delete',
        data: {
          price_plan_id: this.editPlan.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.$refs.deleteModal.click();
          this.getPricePlans();
        })
        .catch(err => {
          console.log(err);
          this.$toasted.error("Price plan is used and can't be deleted", {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    getCurrencies() {
      axios(`${process.env.VUE_APP_API_URL}/common/currency/all`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.currencies = res.data;
      });
    },

    getPlanType(type) {
      if (type === 1) {
        return 'Sourcing';
      } else if (type === 2) {
        return 'Full-service';
      } else if (type === 3) {
        return 'Nearshore';
      } else {
        return 'Freelancers';
      }
    },

    setPlanForEdit(plan) {
      this.editPlan.planID = '';
      if (plan.campaign_id !== null) {
        this.editPlan.planID = plan.campaign_id;
      }

      this.editPlan = {
        ...this.editPlan,
        id: plan.price_plan_id,
        descriptionText: plan.price_plan,
        country: {
          id: plan.country_id,
          name: plan.country_name,
        },
        general: plan.general,
        prFee: parseFloat(plan.programming_test_fee),
        type: plan.type,
        startingFee: parseFloat(plan.starting_fee),
        recruitingFee: parseFloat(plan.recruiting_fee),
        currency: {
          id: plan.currency_id,
          code: plan.currency_code,
        },
        isDefault: plan.default,
        camId: this.editPlan.planID,
        camName: plan.campaign,
      };
    },

    resetModal() {
      this.descriptionText = '';
      this.countryId = '';
      this.general = true;
      this.prFee = '';
      this.type = '1';
      this.startingFee = '';
      this.recruitingFee = '';
      this.currencyId = '';
      this.isDefault = true;
    },
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getAllCountries']),
    formattedCountries() {
      return this.getAllCountries.map(item => `${item.phone_code} ${item.name}`);
    },
  },
  mounted() {
    this.getCurrencies();
    this.getPricePlans();
    this.getCampaigns();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.form-select:disabled {
  background-color: #e9ecef !important;
}

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 48px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: right;
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
